module.exports = __webpack_public_path__ + "media/img/illustrations/icons/applications-speciality-92f8f3f70519bea14016bbe742527371.svg";